import React, { Fragment, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import ArcticViewer from "@/components/ArcticViewer";
import Logo from "@/components/Logo";
import ComputeTabs from "@/components/panel/ComputeTabs";
import NavigateLayer from "@/components/layer/NavigateLayer";
import Toolbar from "@/components/panel/Toolbar";
import RiskLayer from "@/components/layer/RiskLayer";
import Legend from "@/components/panel/Legend";
import PickEventHandler from "@/components/PickEventHandler";
import StartEndPoint from "@/components/layer/StartEndPoint";
import PortLayer from "@/components/layer/PortLayer";
import PolygonLayer from "@/components/layer/PolygonLayer";
import BufferRingLayer from "@/components/layer/BufferRingLayer";
import MouseCoordinatePanel from "@/components/panel/MouseCoordiantePanel";
import RightPanelContainer from "@/components/panel/RightPanelContainer";
import BottomPanelContainer from "@/components/panel/BottomPanelContainer";
import LoginModal from "@/components/Home/components/LoginModal";

function Home() {
  const dispatch = useDispatch();
  const initial = useSelector((state) => state.layer.initial);
  // useEffect(() => {
  //   dispatch.layer.loadDateRange();
  // }, [dispatch]);
  if (initial) return <></>;
  return (
    <Fragment>
      <LoginModal />
      <ArcticViewer>
        <Logo />
        <ComputeTabs />
        <Toolbar />
        <RiskLayer />
        <NavigateLayer />
        <Legend />
        <PickEventHandler />
        <StartEndPoint />
        <PortLayer />
        <PolygonLayer />
        <BufferRingLayer />
        <MouseCoordinatePanel />
        <RightPanelContainer />
        <BottomPanelContainer />
      </ArcticViewer>
    </Fragment>
  );
}

export default Home;
